export default "__VITE_ASSET__DDBjNWo4__"